import { findSelectedOptionLabel } from './utils'

const financeTypeData = [
  {
    label: 'PCP',
    value: 'pcp',
  },
  { label: 'HP', value: 'hp' },
]

export const getFormattedFinanceType = (financeType = '') => {
  if (!financeType || financeType === 'any') return ''
  return findSelectedOptionLabel(financeTypeData, financeType)
}
